/*
 * @Author:
 * @Description:
 * @Date: 2020-04-08 20:14:25
 * @LastEditTime: 2021-04-08 20:46:11
 */

const exposedModule = new WeakMap();

export default function addShare(valueMap: Record<string, any>) {
    // 先挂在window上,用exposedModule
    for (const key in valueMap) {
        if (valueMap.hasOwnProperty(key)) {
            window[(key as any)] = valueMap[key];
        }
    }
}
